export default {
  headerHeight: '55px',
  sidebarWidth: '80px',
  teamMembersWidth: '100px',
  teamMembersHeight: '80px',
  pageMaxWidth: '1200px',
  pageMaxWidthSmallScreen: '900px',
  bodyBackgroundColor: '#f9f9f9',
  teamMembersBackgroundColor: '#f5f5f5',
  headerBackgroundColor: '#fdfdfd',
  mobileNavbarHeight: '60px',
  mobileTeamMembersHeight: '80px'
}



// WEBPACK FOOTER //
// ./src/assets/styles/variables.js